<template>
  <div>
    <div>
      <b-carousel
        v-model="carousel"
        :animated="animated"
        :has-drag="drag"
        :autoplay="autoPlay"
        :pause-hover="pauseHover"
        :pause-info="pauseInfo"
        :pause-info-type="pauseType"
        :interval="interval"
        :repeat="repeat"
        :indicator="indicator"
        :indicator-background="indicatorBackground"
        :indicator-inside="indicatorInside"
        :indicator-mode="indicatorMode"
        :indicator-position="indicatorPosition"
        :indicator-style="indicatorStyle"
        icon-size="is-large"
      >
        <!--          @change="info($event)"-->
        <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
          <a :href="carousel.link">
            <section
              :class="`hero is-medium is-${carousel.color} is-bold`"
              :style="`background-color: ${carousel.color};`"
            >
              <b-image class="image" :src="carousel.image"></b-image>
            </section>
          </a>
        </b-carousel-item>
      </b-carousel>
    </div>
    <br />
    <br />
    <div class="container mt-3">
      <section class="hero is-primary welcome is-small mb-4">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">Accesos directos</h1>
          </div>
        </div>
      </section>
      <div v-if="cargoPrincipal === 'ACADEMICO'" class="box">
        <section class="info-tiles">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performances/declare">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-tasks"></i>
                      </span>
                      <span>Acceder a Evaluación Académica Actual</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="'/people/' + personId">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-book"></i>
                      </span>
                      <span>Mis Evaluaciones Académicas</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>

      <div v-else-if="cargoPrincipal === 'DECANO FING'" class="box">
        <section class="info-tiles">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performance_phases/faculty">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-user-clock"></i>
                      </span>
                      <span>Procesos de la Evaluación Académica</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>
      <div
        v-else-if="cargoPrincipal === 'SECRETARIA ACADEMICA FING'"
        class="box"
      >
        <section class="info-tiles">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performance_phases">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-cogs"></i>
                      </span>
                      <span
                        >Administración Procesos de Evaluación Académica</span
                      >
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performance_phases/faculty">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-user-clock"></i>
                      </span>
                      <span>Procesos de la Evaluación Académica</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performances/manage-performance-participants">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-users-cog"></i>
                      </span>
                      <span>Gestión de participantes del proceso</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/academic_activities/manage-academic-activities">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-list"></i>
                      </span>
                      <span>Gestionar Actividades Académicas</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          
          <!-- Botón de Gestión de Comisiones para Secretaría Académica (siempre visible) -->
          <div v-if="isSecretary" class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box" @click="openCommitteeManagement" style="cursor: pointer;">
                <p class="subtitle is-4">
                  <span class="icon-text">
                    <span class="icon is-medium">
                      <i class="fas fa-users-cog"></i>
                    </span>
                    <span>Gestionar Comisiones Precalificadoras</span>
                  </span>
                </p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performance_precalifications">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-clipboard-check"></i>
                      </span>
                      <span>Bandeja de Precalificación</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>

      <div v-else-if="isCommitteeMember" class="box">
        <section class="info-tiles">
          <!-- FASE 1: Declaración - Directores ven botón de aceptar declaraciones -->
          <div v-if="isDirector && isPhase1" class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="'/admin/units/' + unit">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-user-check"></i>
                      </span>
                      <span>Aceptar Declaraciones</span>
                      
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          
          <!-- FASE 2: Verificación - Académicos suben evidencias, comité NO tiene acceso aún -->
          <div v-else-if="isPhase2" class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="subtitle is-4">
                  <span class="icon-text">
                    <span class="icon is-medium has-text-warning">
                      <i class="fas fa-clock"></i>
                    </span>
                    <span>La precalificación estará disponible en Fase 3</span>
                  </span>
                </p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          
          <!-- FASE 3: Precalificación - Directores y Pares ven bandeja de precalificación -->
          <div v-else-if="isPhase3" class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a href="/performance_precalifications">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-clipboard-check"></i>
                      </span>
                      <span>Bandeja de Precalificación</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            
            <!-- Botón de gestión de comisiones (Secretaría Académica) -->
            <div v-if="isSecretary" class="tile is-parent">
              <article class="tile is-child box" @click="openCommitteeManagement" style="cursor: pointer">
                <p class="subtitle is-4">
                  <span class="icon-text">
                    <span class="icon is-medium">
                      <i class="fas fa-users-cog"></i>
                    </span>
                    <span>Gestionar Comisiones Precalificadoras</span>
                  </span>
                </p>
              </article>
            </div>
            
            <!-- Botón para ver comisión (solo para directores - Solo lectura) -->
            <div v-if="isDirector" class="tile is-parent">
              <article class="tile is-child box" @click="viewCommittee" style="cursor: pointer">
                <p class="subtitle is-4">
                  <span class="icon-text">
                    <span class="icon is-medium">
                      <i class="fas fa-user-friends"></i>
                    </span>
                    <span>Ver Comisión Precalificadora</span>
                    <b-tag v-if="committeeExists" type="is-success" class="ml-2">Configurado</b-tag>
                    <b-tag v-else type="is-warning" class="ml-2">No Configurado</b-tag>
                  </span>
                </p>
              </article>
            </div>
            
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
          
          <!-- Sin fase activa o fase no reconocida -->
          <div v-else class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>

      <div v-else-if="this.isPrincipals === 'true'" class="box">
        <section class="info-tiles">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="'/admin/units/' + unit">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-user-clock"></i>
                      </span>
                      <span>Procesos de la Evaluación Académica</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <!-- <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="'/performances/statistics-menu'">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-chart-pie"></i>
                      </span>
                      <span>Exportación de Estadísticas</span>
                    </span>
                  </p>
                </a>
              </article>
            </div> -->
          </div>
        </section>
      </div>

      <div v-else class="box">
        <section class="info-tiles">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="'/people/' + personId + '/my-academic-data'">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-user-circle"></i>
                      </span>
                      <span>Mi Perfil</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <a :href="sigaUrl" target="_blank">
                  <p class="subtitle is-4">
                    <span class="icon-text">
                      <span class="icon is-medium">
                        <i class="fas fa-school"></i>
                      </span>
                      <span>Ir a SIGA</span>
                    </span>
                  </p>
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import axios from "axios";
import AssignCommitteeModal from './committee/AssignCommitteeModal.vue';

export default {
  name: "landing_page",
  components: {
    AssignCommitteeModal
  },
  props: ["personId", "cargoPrincipal", "unit", "isPrincipals", "sigaUrl", "activePhaseType"],
  created() {
    if (this.isPrincipals === "true") {
      this.carousels = this.carousels_principals;
    } else if (this.cargoPrincipal === "ACADEMICO") {
      this.carousels = this.carousels_academic;
    }
    
    // Cargar comité actual si es director en fase 3 (precalificación)
    if (this.isDirector && this.isPhase3) {
      this.loadCurrentCommittee();
    }
  },
  data() {
    return {
      carousel: 0,
      animated: "fade",
      drag: false,
      autoPlay: true,
      pauseHover: true,
      pauseInfo: false,
      repeat: true,
      pauseType: "is-primary",
      interval: 6000,
      indicator: true,
      indicatorBackground: true,
      indicatorInside: false,
      indicatorMode: "hover",
      indicatorPosition: "is-top",
      indicatorStyle: "is-lines",
      currentCommittee: null,
      committeeExists: false,
      carousels_academic: [
        { color: "#00aea7", image: "Banners/default1.6.png", link: "/#" },
        //{color: '#4f8fde',image:'Banners/academic5.jpg',link:'/people/'+this.personId},
        //{color: '#09b8ab',image:'Banners/academic2.3.jpg',link:'/people/'+this.personId},
        // {color: '#f7bc56',image:'Banners/academic3.2.png',link:'/video_tutorials'},
        //{color: '#009d72',image:'Banners/academic4.2.png',link:'/people/'+this.personId+'/life_record'},
        //{color: '#00aea7',image:'Banners/academic6.jpg',link:'/documents/documents-navigation'},
      ],
      carousels_principals: [
        { color: "#00aea7", image: "Banners/default1.6.png", link: "/#" },
        //{color: '#4f8fde',image:'Banners/principals1.2.png',link:'/admin/units/'+this.unit},
        //{color: '#f7bc56',image:'Banners/principals2.2.png',link:'/life_record'},
        //{color: '#009d72',image:'Banners/principals3.2.png',link:'/life_record'},
        //{color: '#009d72',image:'Banners/academic6.jpg',link:'/documents/documents-navigation'},
      ],
      carousels: [
        { color: "#00aea7", image: "Banners/default1.6.png", link: "/#" },
        //{color: '#4f8fde',image:'Banners/default2.3.png',link:"/people/"+this.personId+"/my-academic-data"},
      ],
    };
  },
  computed: {
    isCommitteeMember() {
      // Detectar si es director de departamento (roles reales: DIR DEPTO INGENIERIA INFORMA, etc.)
      const isDirector = this.cargoPrincipal && this.cargoPrincipal.startsWith('DIR DEPTO');
      
      // Roles de pares académicos y comité precalificador
      const committeeRoles = [
        'PAR ACADEMICO INTERNO',
        'PAR ACADEMICO EXTERNO',
        'COMISION PRECALIFICADOR'
      ];
      
      // Retornar true si es director O miembro del comité
      return isDirector || committeeRoles.includes(this.cargoPrincipal);
    },
    isDirector() {
      // Detectar si el usuario actual es director de departamento
      return this.cargoPrincipal && this.cargoPrincipal.startsWith('DIR DEPTO');
    },
    isSecretary() {
      // Detectar si el usuario es Secretaría Académica
      return this.cargoPrincipal && (
        this.cargoPrincipal.includes('SECRETARIA ACADEMICA') || 
        this.cargoPrincipal.includes('SECRETARIO ACADEMICO') ||
        this.cargoPrincipal.includes('SEC ACADEMICA')
      );
    },
    isPhase1() {
      // Fase 1: DECLARACION DE LOS COMPROMISOS DE DESEMPEÑO
      return this.activePhaseType === 'DECLARACION DE LOS COMPROMISOS DE DESEMPEÑO';
    },
    isPhase2() {
      // Fase 2: VERIFICACION DE COMPROMISOS DE DESEMPEÑO (académicos suben evidencias)
      return this.activePhaseType === 'VERIFICACION DE COMPROMISOS DE DESEMPEÑO';
    },
    isPhase3() {
      // Fase 3: PRECALIFICACION ANUAL DESEMPEÑO POR DEPARTAMENTOS (comité precalifica)
      return this.activePhaseType === 'PRECALIFICACION ANUAL DESEMPEÑO POR DEPARTAMENTOS';
    }
  },
  methods: {
    info(value) {
      this.carousel = value;
      this.$buefy.toast.open({
        message: `This Slide ${value} !`,
        type: "is-info",
      });
    },
    
    async loadCurrentCommittee() {
      try {
        const response = await axios.get('/committee_members/show_for_director');
        if (response.data.success && response.data.committee) {
          this.currentCommittee = response.data.committee;
          this.committeeExists = true;
        } else {
          this.currentCommittee = null;
          this.committeeExists = false;
        }
      } catch (error) {
        console.error('Error al cargar comité:', error);
        this.currentCommittee = null;
        this.committeeExists = false;
      }
    },
    
    openCommitteeManagement() {
      // Navegar a la página de gestión de comités (Secretaría)
      window.location.href = '/committee_management';
    },
    
    viewCommittee() {
      // Directores solo pueden VER su comité (solo lectura)
      if (!this.currentCommittee) {
        this.$buefy.dialog.alert({
          title: 'Comisión No Configurada',
          message: 'Aún no se ha configurado la comisión precalificadora para su departamento. Contacte a la Secretaría Académica.',
          type: 'is-warning',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        });
        return;
      }

      // Mostrar información del comité en modo solo lectura
      const committee = this.currentCommittee;
      const directorName = committee.director && committee.director.name ? committee.director.name : 'N/A';
      const directorEmail = committee.director && committee.director.email ? committee.director.email : 'N/A';
      const member2Name = committee.member_2 && committee.member_2.name ? committee.member_2.name : 'N/A';
      const member2Email = committee.member_2 && committee.member_2.email ? committee.member_2.email : 'N/A';
      const member3Name = committee.member_3 && committee.member_3.name ? committee.member_3.name : 'N/A';
      const member3Email = committee.member_3 && committee.member_3.email ? committee.member_3.email : 'N/A';
      
      const message = `
        <div class="content" style="max-width: 600px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 1.5rem;">
            <h4 class="title is-5 mb-2">Comisión Precalificadora ${committee.process_year}</h4>
          </div>
          
          <div class="box" style="border-left: 5px solid #00d1b2; background-color: #f5f5f5;">
            <div style="display: flex; align-items: center; margin-bottom: 0.75rem;">
              <span class="icon is-medium has-text-primary" style="margin-right: 0.75rem;">
                <i class="fas fa-shield-alt fa-lg"></i>
              </span>
              <p class="has-text-weight-bold is-size-6 has-text-dark">Miembro 1 - Director</p>
            </div>
            <div style="padding-left: 2.5rem;">
              <p class="has-text-weight-semibold is-size-5 mb-1 has-text-dark">${directorName}</p>
              <p class="is-size-6 has-text-grey">${directorEmail}</p>
            </div>
          </div>
          
          <div class="box" style="border-left: 5px solid #3273dc; background-color: #f5f5f5;">
            <div style="display: flex; align-items: center; margin-bottom: 0.75rem;">
              <span class="icon is-medium has-text-info" style="margin-right: 0.75rem;">
                <i class="fas fa-user fa-lg"></i>
              </span>
              <p class="has-text-weight-bold is-size-6 has-text-dark">Miembro 2 - Mismo Departamento</p>
            </div>
            <div style="padding-left: 2.5rem;">
              <p class="has-text-weight-semibold is-size-5 mb-1 has-text-dark">${member2Name}</p>
              <p class="is-size-6 has-text-grey">${member2Email}</p>
            </div>
          </div>
          
          <div class="box" style="border-left: 5px solid #209cee; background-color: #f5f5f5;">
            <div style="display: flex; align-items: center; margin-bottom: 0.75rem;">
              <span class="icon is-medium has-text-link" style="margin-right: 0.75rem;">
                <i class="fas fa-user-graduate fa-lg"></i>
              </span>
              <p class="has-text-weight-bold is-size-6 has-text-dark">Miembro 3 - Académico Externo</p>
            </div>
            <div style="padding-left: 2.5rem;">
              <p class="has-text-weight-semibold is-size-5 mb-1 has-text-dark">${member3Name}</p>
              <p class="is-size-6 has-text-grey">${member3Email}</p>
            </div>
          </div>
          
          <div class="notification is-light" style="border-left: 4px solid #3273dc;">
            <p class="is-size-6 has-text-dark">
              <span class="icon has-text-info">
                <i class="fas fa-info-circle"></i>
              </span>
              Para modificar la comisión, contacte a la Secretaría Académica.
            </p>
          </div>
        </div>
      `;

      this.$buefy.dialog.alert({
        title: 'Información de la Comisión',
        message: message,
        confirmText: 'Cerrar',
        width: '700px'
      });
    },
    
    openAssignCommitteeModal() {
      // Método legacy - ya no se usa para directores
      this.$buefy.toast.open({
        message: 'La gestión de comisiones ahora es realizada por la Secretaría Académica',
        type: 'is-info',
        duration: 3000
      });
    }
  },
};
</script>

<style scoped>
/* Estilos para el modal fullscreen de gestión de comités */
::v-deep .fullscreen-modal .modal-background {
  background-color: rgba(10, 10, 10, 0.95);
}

::v-deep .fullscreen-modal .animation-content {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  margin: 0 !important;
}
</style>
